import React from 'react';
import '../styles/Legal.css';

const Terms = () => {
  return (
    <div className="legal-page">
      <section className="page-hero">
        <div className="container">
          <h1>Terms of Service</h1>
          <p>Please read these terms carefully</p>
        </div>
      </section>

      <section className="legal-content">
        <div className="container">
          <div className="legal-section">
            <h2>Agreement to Terms</h2>
            <p>
              By accessing or using the services of JOY WORLDWIDE CONSULTANCY SERVICES (JWCS),
              you agree to be bound by these Terms of Service. If you do not agree to these
              terms, please do not use our services.
            </p>
          </div>

          <div className="legal-section">
            <h2>Our Services</h2>
            <p>JWCS provides the following services:</p>
            <ul>
              <li>Human Resources consulting</li>
              <li>Global talent placement and recruitment</li>
              <li>Immigration and visa services</li>
              <li>Management consulting services</li>
              <li>Student placement and career services</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2>User Responsibilities</h2>
            <p>When using our services, you agree to:</p>
            <ul>
              <li>Provide accurate and truthful information</li>
              <li>Keep your contact information up to date</li>
              <li>Not misrepresent your qualifications or experience</li>
              <li>Comply with all applicable laws and regulations</li>
              <li>Respect the confidentiality of any proprietary information</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2>Candidate Services</h2>
            <p>
              For job seekers and candidates, we provide placement services at no direct cost.
              However, you acknowledge that:
            </p>
            <ul>
              <li>We cannot guarantee job placement</li>
              <li>Employment decisions are made by hiring employers</li>
              <li>Your information may be shared with potential employers</li>
              <li>You are responsible for the accuracy of your CV and applications</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2>Employer Services</h2>
            <p>
              For employers and businesses using our staffing services:
            </p>
            <ul>
              <li>Service fees are subject to separate agreements</li>
              <li>Candidate information is provided in confidence</li>
              <li>Direct hiring of presented candidates is subject to our placement terms</li>
              <li>We do not guarantee candidate performance or tenure</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2>Intellectual Property</h2>
            <p>
              All content on our website, including text, graphics, logos, and software,
              is the property of JWCS and is protected by copyright and trademark laws.
              You may not reproduce, distribute, or create derivative works without our
              written permission.
            </p>
          </div>

          <div className="legal-section">
            <h2>Limitation of Liability</h2>
            <p>
              JWCS shall not be liable for any indirect, incidental, special, or consequential
              damages arising from your use of our services. Our total liability shall not
              exceed the fees paid for the specific service in question.
            </p>
          </div>

          <div className="legal-section">
            <h2>Governing Law</h2>
            <p>
              These Terms of Service shall be governed by and construed in accordance with
              the laws of the State of Delaware, United States, without regard to its
              conflict of law provisions.
            </p>
          </div>

          <div className="legal-section">
            <h2>Changes to Terms</h2>
            <p>
              We reserve the right to modify these Terms of Service at any time. Changes
              will be effective immediately upon posting to our website. Your continued
              use of our services constitutes acceptance of the modified terms.
            </p>
          </div>

          <div className="legal-section">
            <h2>Contact Information</h2>
            <p>
              For questions about these Terms of Service, please contact us at:
            </p>
            <p>
              <strong>Email:</strong> info@joywcs.com<br />
              <strong>Phone:</strong> +1 647-684-9045 (International) | +91 9380093605 (India)<br />
              <strong>Head Office:</strong> Office: C1 - 1F - SF7384, C1 Building, Ajman Free Zone, AJMAN, UAE<br />
              <strong>India Affiliate Office - BLUE COLLAR MANPOWER MGMT (BCMM):</strong> #52/2, 3rd Floor, 1st Main, "Mutthappa Reddy Heights", diagonally opp. Gopalan Signature Mall, Old Madras Road, Benniganahalli, Doorvaninagar, Bengaluru 560016, Karnataka.
            </p>
            <p><strong>Last Updated:</strong> December 2024</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Terms;
